// extracted by mini-css-extract-plugin
export default {"option":"o7B_p4MSCLwa3ZgqtvVi"};